import * as React from 'react';

import { ComponentType } from 'shared/entities/components/Component';
import { urls } from 'shared/entities/domain';
import { useTypedTranslation } from 'shared/entities/localization';
import { Button } from 'shared/newComponents/buttons';
import PaletteIcon from 'shared/newComponents/icons/PaletteIcon';
import Typography from 'shared/newComponents/Typography';
import { ButtonColor, ButtonSize } from 'shared/newEntities/components/Button';
import {
  TypographyColor,
  TypographySize,
  TypographyType,
  TypographyWeight
} from 'shared/newEntities/components/Typography';
import { useProjectStore } from 'stores/index';
import { IconSize, IconStyle } from 'shared/entities/components/Icon';

import './WidgetCreateDesign.modules.scss';

type Props = {
  className?: string;
};

const WidgetCreateDesign: React.FC<Props> = ({ className }) => {
  const { t } = useTypedTranslation('newContainers');
  const projectStore = useProjectStore();

  const customizationUrl = projectStore.projectId
    ? urls.PROJECT.tabs.WIDGET_CUSTOMIZATION.create({
        projectId: projectStore.projectId
      })
    : '';

  return (
    <div className={className} styleName="widget-design">
      <div styleName="widget-design__icon">
        <PaletteIcon iconStyle={IconStyle.blue} iconSize={IconSize.L} />
      </div>

      <Typography
        fontType={TypographyType.text}
        fontWeight={TypographyWeight.semiBold}
        fontSize={TypographySize.s}
        styleName="widget-design__title"
      >
        {t('ChannelsModal.ChannelForm.Widget.CreateDesign.title')}
      </Typography>

      <Typography
        fontType={TypographyType.text}
        fontSize={TypographySize.xs}
        fontColor={TypographyColor.secondary}
        styleName="widget-design__description"
      >
        {t('ChannelsModal.ChannelForm.Widget.CreateDesign.description')}
      </Typography>

      <Button
        to={customizationUrl}
        type={ComponentType.link}
        size={ButtonSize.sm}
        color={ButtonColor.gray}
        styleName="widget-design__button"
        fullWidth={true}
      >
        <div styleName="widget-design__button-text">
          <PaletteIcon iconSize={IconSize.S} />
          {t('ChannelsModal.ChannelForm.Widget.CreateDesign.button')}
        </div>
      </Button>
    </div>
  );
};

export default WidgetCreateDesign;
